import Tls from "@/services/Tls";
import TlsCasesList from "@/components/TlsCase/List";

const name = "Home";

const data = function () {
	return {
		chart: null,
		messagesLoading: true,
		tlsCasesLoading: true,
		tlsCasesToday: null,
		messagesToday: null,
		messagesCount: null,
		tlsCases: [],
		tlsCasesCount: null,
		server: {
			time: null,
			status: null,
			success: true,
			color: "#0acf97"
		},
	};
};

const removeCaseFromList = function (tlsCase) {
	const data    = Object.assign([], this.tlsCases);
	this.tlsCases = data.filter(c => c != tlsCase);
};

const fetchTlsCases = function() {
	Tls.Cases.all({ limit: 10 }).then(response => {
		this.tlsCasesLoading  = false;
		this.tlsCases         = response.cases;
		this.tlsCasesCount    = response.total_count;
	});
};

export default {
	name,
	data,
	components: {
		TlsCasesList
	},
	beforeDestroy() {
		clearInterval(this.intervaltlsCases);
	},
	mounted() {
		fetchTlsCases.bind(this)();
    
		Tls.Cases.stats().then(response => {
			this.tlsCasesToday = response.stats.today;
		});
    
		Tls.Messages.stats().then(response => {
			this.messagesLoading = false;
			this.messagesToday   = response.stats.today;
		});
    
		Tls.Messages.chart().then(chart => {
			this.chart = chart;
		});
    
		this.intervaltlsCases = setInterval(() => {
			this.tlsCasesLoading = true;
			fetchTlsCases.bind(this)();
		}, 15000);
	},
	methods: {
		removeCaseFromList
	}
};